import { GET_LEADERBOARD_DATA } from "lib/constants";
import { postAPICall } from "../lib/callApi";

export const fetchLeaderboardData = async (payload) => {
  const data = await postAPICall(GET_LEADERBOARD_DATA, true, payload);
  return data;
};
